import { LucideIcon } from "lucide-react";

interface NavigationCardProps {
  icon: LucideIcon;
  title: string;
  imageUrl?: string;
  onClick?: () => void;
}

export const NavigationCard = ({ icon: Icon, title, imageUrl, onClick }: NavigationCardProps) => {
  return (
    <button className="btn btn-primary p-0 overflow-hidden relative" onClick={onClick}>
      {imageUrl ? (
        <img 
          src={imageUrl} 
          alt={title} 
          className="w-full h-full object-cover" 
        />
      ) : (
        <>
          <Icon className="btn-icon" strokeWidth={1.5} />
          <span className="btn-text">{title}</span>
        </>
      )}
    </button>
  );
};
